/**  Handles a search filter UI */
class FilterComponent {
    private filterElement: JQuery;
    private advancedElement: JQuery;
    private toggleState: JQuery;

    /**  Initialises the search filter component */
    init() {
        this.filterElement = $(".filter");
        if (this.filterElement.length > 0) {
            this.initFilterToggle();
        }
    }

    private initFilterToggle() {
        this.advancedElement = this.filterElement.find(".advanced");

        if (this.advancedElement.length > 0) {
            this.toggleState = this.filterElement.find(".advanced-toggle-state");

            var hideButton = this.createButton("Show fewer options", "hide-button");
            var showButton = this.createButton("Show more options", "show-button");

            showButton.on("click", (event: JQuery.TriggeredEvent) => {
                this.showAdvanced();
                event.preventDefault();
            });

            hideButton.on("click", (event: JQuery.TriggeredEvent) => {
                this.hideAdvanced();
                event.preventDefault();
            });

            var toggleElement = this.filterElement.find(".advanced-toggle");
            toggleElement.append(showButton);
            toggleElement.append(hideButton);

            var state = this.toggleState.val().toString().toLowerCase();
            if (!state) {
                state = "false";
            }
            this.filterElement.attr("aria-expanded", state);
        }
    }

    private hideAdvanced() {
        this.advancedElement.slideUp((event: JQuery.TriggeredEvent) => {
            this.filterElement.attr("aria-expanded", "false");
            this.toggleState.val("false");
        });
    }

    private showAdvanced() {
        this.advancedElement.slideDown((event: JQuery.TriggeredEvent) => {
            this.filterElement.attr("aria-expanded", "true");
            this.toggleState.val("true");
        });
    }

    private createButton(text: string, className: string) : JQuery {
        var button = $("<a/>");

        var label = $("<span/>");
        label.addClass("label");
        label.text(text);

        button.append(label);
        button.attr("href", "#");
        button.addClass(className);

        return button;
    }
}

$(function () {
    let filter = new FilterComponent();
    filter.init();
});